import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Col, Label, FormGroup } from 'reactstrap';
import { Setting } from '../../../models';
import { Utils } from '../../../services';
import { request_mobile_preview_boot } from '../MobileAppPreviewDock/mobilePreviewBoot';

import './ConfigSettings.css';

const AppNameField = ({ input, placeholder }) => {
    const focus_value_ref = useRef(input.value || '');

    return (
        <input
            { ...input }
            className="form-control"
            type="text"
            maxLength={ 30 }
            autoComplete="off"
            placeholder={ placeholder }
            onFocus={ (e) => {
                focus_value_ref.current = e.target.value;
                input.onFocus(e);
            } }
            onBlur={ (e) => {
                const changed = e.target.value !== focus_value_ref.current;
                input.onBlur(e);
                if (changed)
                    request_mobile_preview_boot();
            } }
        />
    );
};

const ConfigSettings = (props) => {
    const { t, i18n } = useTranslation();
    const user = useSelector(state => state.auth.user);
    const { env, tickettypes, salepoints, articles, articleCategories, postCategories } = props;

    if (!props.setting)
        return null;

    const keys = [
       'appName',
       'edition',
       'kronosUri', 'kronosApiKey',
       'salepointId'
    ];

    const appNamePlaceholder = Utils.localized_or_fallback(
        props.setting?.customer?.name,
        i18n.language
    ) || '';

    const renderSetting = key => {
        const name = `mobile.${env}.${key}`;
        const { role, hideLabel, input } = Setting.propertyForm(t, props.setting, name, tickettypes, salepoints, articles, articleCategories, postCategories);

        return (
            <React.Fragment key={ `${env}-${key}` }>
                {(user?.isSuperAdmin() || (!role && user?.can('editSelf', 'settings'))) &&
                    <FormGroup row>
                        {!hideLabel && (
                            <Label for="_id" sm={3}>
                                {key === 'salepointId'
                                    ? t('common.salepoint_one')
                                    : t(`settings.mobile.${key}`)}
                            </Label>
                        )}
                        <Col sm={hideLabel ? 12 : 9}>
                            { key === 'appName' ? (
                                <Field
                                    component={ AppNameField }
                                    name={ name }
                                    placeholder={ appNamePlaceholder }
                                />
                            ) : input }
                            { key === 'appName' && (
                                <p className="text-muted small mb-0 mt-1">
                                    { t('settings.mobile.appName_help') }
                                </p>
                            ) }
                        </Col>
                    </FormGroup>
                }
            </React.Fragment>
        );
    }

    return (
        <div className="ConfigSettings">
            { keys.map(key => renderSetting(key)) }
        </div>
    );
}

export default ConfigSettings;
